import React, { useCallback } from 'react';
import Clickable from '@prisjakt/ui-clickable';
import * as NewStyle from '../../styles';
import * as S from '../../styles-old';
import { IAlternativePriceRowProps } from './types';
import StockPriceInfo from '../components-old/stock-price-info';
import OptionsColumn from './options-cloumn';
import { AlternativePrice } from 'src/types';
import { IconChevronRight } from '@prisjakt/ui/icon';

const AlternativePriceRow = ({
  campaign,
  onClickOut,
  price,
  store: priceStore,
  productImage,
  tableLinkProps,
  priceDisplay,
  isInternationalPrice,
}: IAlternativePriceRowProps) => {
  const featured = priceStore && priceStore.featured;

  const handleClickOut = useCallback(
    (e: React.MouseEvent) => onClickOut(e, price.id),
    [price.id, onClickOut]
  );

  return (
    <S.AltRow featured={Boolean(featured)}>
      <OptionsColumn
        price={price}
        store={priceStore}
        productImage={productImage}
      />
      {featured && price.externalUri && (
        <S.ActionArea
          container={Clickable}
          containerProps={{
            to: price.externalUri,
            'aria-label': price.name,
            rel: tableLinkProps.rel,
            isExternal: true,
            onMouseDown: tableLinkProps.onMouseDown,
            onTouchStart: tableLinkProps.onTouchStart,
            onKeyDown: tableLinkProps.onKeyDown,
            target: tableLinkProps.target,
            onClick: handleClickOut,
          }}
        >
          <NewStyle.Content>
            <NewStyle.TopMiddleRow isAlternative featured={featured}>
              <NewStyle.ProductNameColumn>
                <NewStyle.ProductName featured={featured} isAlternative>
                  {price.name}
                </NewStyle.ProductName>
              </NewStyle.ProductNameColumn>
              <StockPriceInfo
                featured={Boolean(featured)}
                campaign={getCampaignById(price, campaign)}
                price={price.price}
                priceDisplay={priceDisplay}
                stock={price.stock}
                isMemberPrice={Boolean(price.isMemberPrice)}
                countryCode={priceStore && priceStore.countryCode}
                isInternationalPrice={isInternationalPrice}
                shipping={price.shipping}
              />
            </NewStyle.TopMiddleRow>
            <NewStyle.GoToStoreColumn
              isAlternative
              featured={Boolean(price.externalUri || featured)}
            >
              <IconChevronRight />
            </NewStyle.GoToStoreColumn>
          </NewStyle.Content>
        </S.ActionArea>
      )}

      {(!featured || !price.externalUri) && (
        <S.Link {...tableLinkProps} onClick={handleClickOut}>
          <NewStyle.TopMiddleRow>
            <NewStyle.ProductNameColumn featured>
              <NewStyle.ProductName featured={Boolean(featured)} isAlternative>
                {price.name}
              </NewStyle.ProductName>
            </NewStyle.ProductNameColumn>
            <StockPriceInfo
              featured={Boolean(featured)}
              campaign={getCampaignById(price, campaign)}
              price={price.price}
              priceDisplay={priceDisplay}
              stock={price.stock}
              isMemberPrice={false}
              countryCode={priceStore && priceStore.countryCode}
              isInternationalPrice={isInternationalPrice}
            />
          </NewStyle.TopMiddleRow>
        </S.Link>
      )}
    </S.AltRow>
  );
};

const getCampaignById = (item: AlternativePrice, campaign: any) => {
  return campaign?.price &&
    campaign?.media &&
    campaign?.name &&
    item.id === campaign.price.id
    ? campaign
    : null;
};

export default AlternativePriceRow;
